import _ from "lodash";
import { queryWaterProviderWithDocs } from "./api";
import { PROVIDER_FIELDS, QUERY_URL_AND } from "./constants";
import { FilterMetadataApiReturn } from "./types";
import { SearchParams } from "../ProviderFilter";
import { WaterProvider } from "./types";
import { getProviders } from "./fetchProviders";

export const filterProvidersBySearchParams = (providers: WaterProvider[], searchParams: SearchParams) => {
    if (!searchParams) return undefined;

    const { providerRegion, providerSize } = searchParams;
    const providerRegionMap =
        providerRegion?.reduce((prev, cur) => {
            prev[cur] = 1;
            return prev;
        }, {}) ?? {};

    const providerSizeMap =
        providerSize?.reduce((prev, cur) => {
            prev[cur] = 1;
            return prev;
        }, {}) ?? {};

    const _providers = providers?.filter(
        d =>
            (!providerRegion?.length || providerRegionMap[d.region] === 1) &&
            (!providerSize?.length || providerSizeMap[d.connectionSizeCategory] === 1)
    );

    return _providers;
};

export const getFieldQueryWithSearchParamsAndMetadata = (
    metadata: FilterMetadataApiReturn,
    searchParams: SearchParams
): string => {
    if (
        !searchParams ||
        !metadata
        // ||
        // !_.flattenDeep(_.values(searchParams)).filter(d => d != null && d.trim() !== "")?.length
    )
        return undefined;

    const query = _.join(
        _.keys(searchParams)
            .filter(key => {
                return metadata[key];
            })
            .map(key => {
                const { options } = metadata[key];
                const values = searchParams?.[key] ?? [];

                const field = _.uniq(
                    (options ?? []).map(({ access }) => access).filter(d => d != null && d.toString().trim() !== "")
                )?.[0];

                if (field == null) return undefined;

                const _values = values.map(value => `"${value}"`).filter(d => d != null && d.toString().trim() !== "");
                if (!_values.length) return undefined;

                return `${field}:(${_.join(_values, " OR ")}) `;
            })
            .filter(d => d != null),
        " AND "
    );

    return query;
};

// use in search page
export const fetchProvidersByFilters = async (
    metadata: FilterMetadataApiReturn,
    searchParams: SearchParams,
    options?: RequestInit
): Promise<WaterProvider[]> => {
    if (!searchParams) return undefined;

    const providers = getProviders();

    if (providers?.length > 0) {
        const _providers = filterProvidersBySearchParams(providers, searchParams);
        return _providers;
    }

    const query = getFieldQueryWithSearchParamsAndMetadata(metadata, searchParams);

    // console.log(query);

    if (query == null) {
        return undefined;
    }

    console.log("fetchProvidersByFilters");

    const solrQuery = _.join(
        [
            "q=*:*",
            "rows=1000",
            "facet=on",
            // `fl=its_tid,pure_strings_sname,pure_strings_admin_id,pure_strings_type,pure_strings_connection_size_ct,pure_strings_residential_tariff_struct,fts_connection_size,fts_population,fts_area,fts_dam_capacity,fts_dam_num,fts_employee_num,pure_strings_region,tm_X3b_en_description`,
            `fl=${PROVIDER_FIELDS}`,
            `fq=${query ?? ""}`
        ],
        QUERY_URL_AND
    );

    return queryWaterProviderWithDocs(solrQuery, options);
};
